import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

const { background, grey } = colors;
const { borderRadius } = borders;

/** Fluent card: layered surface, 1px stroke, 8px corners, no hover lift. */
const card = {
  styleOverrides: {
    root: {
      display: "flex" as const,
      flexDirection: "column" as const,
      position: "relative" as const,
      minWidth: 0,
      wordWrap: "break-word" as const,
      backgroundColor: background.paper,
      backgroundClip: "border-box" as const,
      border: `1px solid ${background.cardBorder}`,
      borderRadius: borderRadius.lg,
      boxShadow: boxShadows.xs,
      overflow: "visible" as const,
      transition:
        "box-shadow 0.15s cubic-bezier(0.33, 0, 0.67, 1), border-color 0.15s cubic-bezier(0.33, 0, 0.67, 1)",

      "&:hover": {
        boxShadow: boxShadows.sm,
        borderColor: grey[300],
      },
    },
  },
};

export default card;
